var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 15,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333334 0 0 1.3333334 0 0)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAVCAYAAACZm7S3AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD7SURBVDhPY/iPBP5cu/z/z4WzKJgBHwBrAir6lhj2/4uzGQaGKsMO/v/8+f9rqCdY4bdo///fizJRMFQZdvB7x2aIxrQYsNPRAVQZdvBz4SywZhCNC/xas/w/yIXogKDmn9P6wPLfK/IxDCCo+e+dm/+/+jtjNYAoZ+MygCjNIIDNAKI1gwC6ASRpBgGQASD1IEyy5p9dTRDNnjakaUbW+OfUMeI1o2sEAaI0Y9MIAgQ1w1IYukYQIKgZHD3AXIeuEQQYfi5bANE8oQMqhAqg+Qc7gMUbKPJ/79tFekkCSi1gf2HBUGXYAUjzv8+f/v/atBajFMFfkjAwAACfPnwUomfrBgAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    width: 11.25,
    height: 15.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fb38128ed457929bb5f5c63b76e33829.svg";
export { ForwardRef as ReactComponent };